import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { appRoute } from '../../app/route-base'
import { lazyComponent } from '../../lib/lazy'
import type { WebModule } from '../../lib/modules'
import { isAuditor } from '../../lib/permissions'

export const portalRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/audit-portal',
  component: lazyRouteComponent(() => import('./AuditPortalPage'), 'AuditPortalPage'),
})

export const module: WebModule = {
  routes: [portalRoute],
  entityOverrides: {
    audit: {
      ListPage: lazyComponent(() => import('./AuditListPage'), 'AuditListPage'),
      DetailPage: lazyComponent(() => import('./AuditDetailPage'), 'AuditDetailPage'),
    },
    audit_request: {
      DetailPage: lazyComponent(() => import('./RequestDetailPage'), 'RequestDetailPage'),
    },
  },
  nav: [
    {
      key: 'audit-portal',
      label: 'Auditor portal',
      to: '/audit-portal',
      group: 'Compliance',
      order: 51,
      icon: 'audits',
      visible: (viewer) => isAuditor(viewer),
    },
  ],
}
